import { useAuth } from "scenes/Authentication/components/AuthProvider";

function useSignUpVersion() {
  const { user } = useAuth();

  return user?.attributes?.["custom:signUpVersion"] || "";
}

export default useSignUpVersion;
